import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing, $done } from "services/activity/action";
import { $requesting, $success, $failure } from "services/form/action";

export const MODULE = "Job";
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, "Get", (id) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/public/job/${id}`)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $getByManifest = ActionCreator.Async(MODULE, "GetByManifest", (id) => {
  return async (dispatch) => {
    dispatch($processing($getByManifest.OPERATION));

    return await Rest.GET(`${API_URL}/public/job/manifest/${id}`)
      .then((response) => {
        dispatch($getByManifest.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getByManifest.OPERATION)));
  };
});

export const $pickup = ActionCreator.Async(MODULE, "Pickup", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/job/pickup`, payload)
      .then((response) => {
        dispatch($pickup.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});
